import { Link } from "react-router-dom";
import { categories } from "@/mocks/comics";

export default function Footer() {
  return (
    <footer className="mt-16 border-t border-background-200 bg-background-100">
      <div className="container-page grid grid-cols-1 gap-8 py-12 sm:grid-cols-2 lg:grid-cols-4">
        <div className="lg:col-span-1">
          <Link to="/" className="flex items-center gap-2.5">
            <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-500 font-heading text-xl font-bold text-background-50">
              漫
            </span>
            <span className="font-heading text-lg font-bold text-foreground-950">我爱漫画网</span>
          </Link>
          <p className="mt-4 max-w-xs text-sm leading-relaxed text-foreground-600">
            面向漫荒读者的漫画推荐与策展内容站，收录高分漫画、冷门佳作与必看榜单，帮你快速找到好漫画，告别剧荒。
          </p>
          <div className="mt-4 flex items-center gap-2 text-lg text-foreground-500">
            <a href="https://x.com" target="_blank" rel="nofollow noopener noreferrer" aria-label="微博" className="flex h-8 w-8 items-center justify-center rounded-full hover:bg-primary-100 hover:text-primary-600">
              <i className="ri-weibo-line" />
            </a>
            <a href="https://weixin.qq.com" target="_blank" rel="nofollow noopener noreferrer" aria-label="微信" className="flex h-8 w-8 items-center justify-center rounded-full hover:bg-primary-100 hover:text-primary-600">
              <i className="ri-wechat-line" />
            </a>
            <a href="https://space.bilibili.com" target="_blank" rel="nofollow noopener noreferrer" aria-label="哔哩哔哩" className="flex h-8 w-8 items-center justify-center rounded-full hover:bg-primary-100 hover:text-primary-600">
              <i className="ri-bilibili-line" />
            </a>
          </div>
        </div>

        <nav aria-label="站内导航">
          <h3 className="mb-4 text-sm font-bold text-foreground-900">站内导航</h3>
          <ul className="space-y-2.5 text-sm text-foreground-600">
            <li><Link to="/" className="transition-colors hover:text-primary-600">首页</Link></li>
            <li><Link to="/rankings" className="transition-colors hover:text-primary-600">推荐榜单</Link></li>
            <li><Link to="/about" className="transition-colors hover:text-primary-600">关于我们</Link></li>
            <li><Link to="/faq" className="transition-colors hover:text-primary-600">常见问题</Link></li>
            <li><Link to="/contact" className="transition-colors hover:text-primary-600">联系我们</Link></li>
          </ul>
        </nav>

        <nav aria-label="推荐栏目">
          <h3 className="mb-4 text-sm font-bold text-foreground-900">推荐栏目</h3>
          <ul className="space-y-2.5 text-sm text-foreground-600">
            {categories.map((c) => (
              <li key={c.slug}>
                <Link to={`/category/${c.slug}`} className="transition-colors hover:text-primary-600">
                  {c.name}
                </Link>
              </li>
            ))}
          </ul>
        </nav>

        <div>
          <h3 className="mb-4 text-sm font-bold text-foreground-900">联系我们</h3>
          <ul className="space-y-2.5 text-sm text-foreground-600">
            <li className="flex items-center gap-2">
              <i className="ri-mail-line text-primary-500" />
              hello@woaimanhua.example
            </li>
            <li className="flex items-center gap-2">
              <i className="ri-time-line text-primary-500" />
              每周更新补番清单
            </li>
            <li className="flex items-center gap-2">
              <i className="ri-question-line text-primary-500" />
              <Link to="/faq" className="hover:text-primary-600">阅读常见问题</Link>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-background-200">
        <div className="container-page flex flex-col items-center justify-between gap-2 py-5 text-xs text-foreground-500 sm:flex-row">
          <p>© {new Date().getFullYear()} 我爱漫画网 · 漫荒推荐、补番清单、高分漫画与冷门佳作推荐平台</p>
          <p className="flex items-center gap-1.5">
            <span>让每一个漫荒时刻，都能找到下一本好漫画</span>
          </p>
        </div>
      </div>
    </footer>
  );
}